var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"currency",rawName:"v-currency",value:(_vm.options),expression:"options"}],ref:"input",attrs:{"value":_vm.formattedValue,"outlined":"","label":_vm.label},on:{"change":_vm.onChange,"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }